import type { FC } from 'react';

import { Text } from '@eluve/components';

export const FindingEvidence: FC<{ evidence: string | null }> = ({
  evidence,
}) => {
  if (!evidence) return null;

  return (
    <Text size="xs" color="tertiary" className="mt-2 italic">
      “{evidence}”
    </Text>
  );
};
